import type { CssResolvers } from '@sites/entity-core';
import { themeColorCss } from '@sites/site-theme/src/utils/variables';
import { encodeFileUrl, encodeFileUrlWithResize } from '@components/sp-file-manager/src/helpers';
import { environment } from '@web-env/environment';

/**
 * The css-vars builders are framework-free and each app has its own CDN base, so
 * the colour and image resolvers are bound once per app, here.
 */
export const CSS_RESOLVERS: CssResolvers = {
    colorCss: themeColorCss,
    imageCss: (file) => encodeFileUrlWithResize(file as never, environment.fileManagerCdnUrl),
};

/** The header row's background is served as picked, without a resize request. */
export const SECTION_CSS_RESOLVERS: CssResolvers = {
    colorCss: themeColorCss,
    imageCss: (file) => encodeFileUrl(file as never, environment.fileManagerCdnUrl),
};
